import React, { ComponentType, FC } from 'react'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'
import { Box, Typography } from 'transfix-ui/core'
import { IconWrapper, TBrandColor, useColorStyles } from 'transfix-ui'

export interface IEldProviderFeature {
  /**
   * @example CheckFilled
   */
  Icon: ComponentType<ICommonProps>
  /**
   * @example 'skyBlue6'
   */
  color: TBrandColor
  /**
   * @example '24/7 Vehicle Tracking'
   */
  title: string
  /**
   * @example 'Track the location of any load you add to Transfix FMS.'
   */
  subtitle?: string
}

interface IEldProviderRowFeaturesProps {
  features: IEldProviderFeature[]
}

/**
 * Lists features based on array value for ELD Provider
 */
export const EldProviderRowFeatures: FC<IEldProviderRowFeaturesProps> = ({ features = [] }) => {
  const colors = useColorStyles()
  return (
    <Box
      display='flex'
      justifyContent='center'
      flexDirection='column'
      mb={-0.5}
      data-test='eld-provider-row-features'>
      {features.map(({ Icon, color, subtitle, title }) => (
        <Box
          flex='0 0 auto'
          display='flex'
          alignItems='center'
          mb={0.5}
          data-test='eld-feature'
          key={title}>
          <IconWrapper
            Icon={Icon}
            color={color}
            BoxProps={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              // fixes offset
              paddingBottom: '2px',
            }}
          />
          <Box flex='1 1 auto' display='flex' flexDirection='column' pl={1}>
            <Box>
              <Typography variant='subtitle2' component='div' className={colors[color]}>
                {title}
              </Typography>
            </Box>
            {subtitle && (
              <Box>
                <Typography variant='caption' component='div' className={colors.coolGray5}>
                  {subtitle}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  )
}
